export async function pollingAction(action) {
  return pollForCondition(() => checkJobComplete(action), 500, 90000);
}

function pollForCondition(conditionFn, interval, timeout) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const poll = () => {
      conditionFn()
        .then((result) => {
          if (result) {
            resolve(result);
          } else if (timeout && Date.now() - startTime > timeout) {
            reject(new Error('Polling timed out'));
          } else {
            setTimeout(poll, interval);
          }
        })
        .catch((err) => {
          reject(err);
        });
    };

    poll();
  });
}

async function checkJobComplete(checkingAction) {
  const job = await checkingAction();

  if (job.status === 'FAILED') {
    throw new Error(JSON.stringify(job));
  }

  if (job.status === 'COMPLETED') {
    return job;
  }
}
